export const isValidEmail = (email: string) => {
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|([a-zA-Z0-9]([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

export const isNetworkError = (error: any) => {
    return error.code === 'ERR_NETWORK';
};

export const removeUndefinedAttribute = (values: any = {}) => {
    Object.keys(values).forEach(key => {
        if (
            values[key] === null ||
            values[key] === undefined ||
            values[key] === 'undefined' ||
            values[key] === ''
        ) {
            delete values[key];
        }
    });
    return values;
};

export const getRandomCharsFromString = (charset: string, length: number) => {
    return new Array(length)
        .fill(0)
        .map(() => charset[Math.floor(Math.random() * charset.length)])
        .join('');
};

export function formatLocaleDateTimeString(date: string) {
    if (!date) return '';
    return new Date(date)
        .toLocaleString('en-GB', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        })
        .split('/')
        .join('-')
        .replace(',', '');
}

export function formatLocaleDateString(date: string) {
    if (!date) return '';
    const longEnGBFormatter = new Intl.DateTimeFormat('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    const newDate = longEnGBFormatter.format(new Date(date));

    const today = new Date();
    const todayString = longEnGBFormatter.format(today);
    if (newDate === todayString) {
        return 'Now';
    }
    return newDate;
}

export function formatNumber(number: number) {
    if (!number) return '';
    const newValue = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(number);
    return newValue.replace('.00', '');
}

export function formatNumberNoneCurrency(val: number) {
    if (!val) return '';
    const value = new Intl.NumberFormat('en-US', { style: 'decimal' }).format(
        val
    );
    // need to format tofixed 2 decimal
    const parts = value.split('.');
    if (parts.length === 1) {
        return `${value}`;
    }
    if (parts.length === 2) {
        if (parts[1].length === 1) {
            return `${value}0`;
        }
        return value;
    }
    return value;
}

export const reorder = (
    list: any[] | undefined,
    startIndex: number,
    endIndex: number
): any[] => {
    const result = list ? [...list] : [];
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

export const timeAgo = (date: string) => {
    const seconds = Math.floor(
        (new Date().getTime() - new Date(date).getTime()) / 1000
    );
    let interval = seconds / 31536000;
    if (interval > 1) {
        return Math.floor(interval) + ' years ago';
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return Math.floor(interval) + ' months ago';
    }
    interval = seconds / 86400;
    if (interval > 1) {
        return Math.floor(interval) + ' days ago';
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return Math.floor(interval) + ' hours ago';
    }
    interval = seconds / 60;
    if (interval > 1) {
        return Math.floor(interval) + ' minutes ago';
    }
    if (seconds === 0) {
        return 'Just now';
    }
    return Math.floor(seconds) + ' seconds ago';
};
